import { Theme } from '@mui/material';

import { createStyles, makeStyles } from '@mui/styles';

export default makeStyles((theme: Theme) =>
  createStyles({
    appBar: {
      position: 'relative',
      backgroundColor: 'white',
    },
    dialogTitle: {
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
    },
  }),
);
